export const DEFAULT_LANG = 'en' as const;

export const DESTROYED_ERR_MSG = 'this instance is already destroyed';

export const ZOOM = 3.7795275591;

export const SELECTABLE_CLASSNAME = 'selectable';

export const RULER_HEIGHT = 28;

export const PAGE_BOTTTOM_Y = 176;

export const SIDEBAR_WIDTH = 300;
